<template>
	<div>...</div>
</template>
<script>
	export default {
		mounted() {
			this.$emit('setHeader', ['Linhas', 'SD2000']);
		},
	};
</script>



// WEBPACK FOOTER //
// src/components/sd2000/entradas/index.vue